import { styled } from '@mui/system';
import { Typography, Box, Button } from '@mui/material';

export const TitleStyled = styled(Typography)(({ theme }) => ({
  padding: '0.9375rem',
  fontWeight: 450,
  color: theme.palette.primaryDark,
  lineHeight: '1.75rem',
  fontFamily: 'BGBold'
}));

export const ValueStyled = styled(Typography)(({ theme }) => ({
  padding: '0.9375rem',
  marginLeft: 'auto',
  fontSize: '1.875rem',
  lineHeight: '34px',
  color: theme.palette.primaryDark,
  fontFamily: 'Calibri'
}));

export const BoxStyled = styled(Box)({
  width: '100%',
  margin: '1.875rem 0',
  display: 'flex',
  borderRadius: '0.9375rem',
  background: 'rgba(91, 194, 231, 0.25)'
});

export const InputBoxStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  marginTop: '1.875rem',
  borderRadius: '0.9375rem',
  border: `0.0625rem solid ${theme.palette.dividerBorder}`
}));

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  color: theme.palette.primaryDark,
  fontFamily: 'BGBold',
  padding: '1.25rem'
}));

export const InfoButtonStyled = styled(Button)({
  height: '1.25rem',
  minWidth: '1.25rem',
  marginLeft: 'auto'
});
